import styles from './text-error.module.scss';
export const TextError = ({ errorMessage, error }) => {
  return (
    <span className={styles['error']} style={{ opacity: error ? 1 : 0 }}>
      <i className='material-icons'>warning</i> <span> error! </span>
      {errorMessage}
    </span>
  );
};
